import { useRef, useEffect, useCallback } from 'react'

const ScrollableContainer = ({
  children,
  onScrollToBottom,
  className = '',
  threshold = 5,
  ...props
}) => {
  const containerRef = useRef(null)

  const handleScroll = useCallback(() => {
    const container = containerRef.current
    if (container) {
      const { scrollTop, scrollHeight, clientHeight } = container
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - threshold
      if (isAtBottom && onScrollToBottom) {
        onScrollToBottom()
      }
    }
  }, [onScrollToBottom, threshold])

  useEffect(() => {
    const container = containerRef.current
    if (container) {
      container.addEventListener('scroll', handleScroll)
      // Check initial state in case content doesn't need scrolling
      // Only fire if content has rendered (scrollHeight > 0) and doesn't overflow
      const { scrollHeight, clientHeight } = container
      if (scrollHeight > 0 && scrollHeight <= clientHeight && onScrollToBottom) {
        onScrollToBottom()
      }
      return () => container.removeEventListener('scroll', handleScroll)
    }
    return undefined
  }, [handleScroll, onScrollToBottom])

  return (
    <div ref={containerRef} className={className} {...props}>
      {children}
    </div>
  )
}

export default ScrollableContainer
